import {Radio, Tooltip} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {
  StyledDiscountFormContainer,
  StyledDiscountFormItem,
} from "../styles/discount-form.styles";

export function DiscountCodeUsageFormFieldV2() {
  const {control, formState} = useFormContext();
  return (
    <StyledDiscountFormContainer>
      <div
        className="form-header"
        style={{display: "flex", alignItems: "center", gap: "8px"}}
      >
        Usage limit
        <Tooltip
          title={
            <div>
              <p>
                "One-time use per customer" allows the discount code to be used for a
                single purchase by an individual customer.
              </p>
              <p style={{marginTop: "8px"}}>
                "Multiple use per customer" allows the discount code to be used several
                times by different customers until it reaches expiration date.
              </p>
            </div>
          }
        >
          <QuestionCircleOutlined
            style={{fontSize: "14px", color: "#8c8c8c", cursor: "help"}}
          />
        </Tooltip>
      </div>
      <div className="form-content">
        <StyledDiscountFormItem style={{marginBottom: 0}}>
          <Controller
            control={control}
            name="usage"
            render={({field: {onChange, value}}) => (
              <>
                <Radio.Group
                  value={value}
                  onChange={(e) => {
                    onChange(e.target.value);
                  }}
                  size="large"
                >
                  <Radio value={"one time"}>One time use per customer</Radio>
                  <Radio value={"multiple"}>Multiple use per customer</Radio>
                </Radio.Group>
                {formState.errors.usage?.message && (
                  <div role="alert" className="ant-form-item-explain-error">
                    {formState.errors.usage.message as string}
                  </div>
                )}
              </>
            )}
          />
        </StyledDiscountFormItem>
      </div>
    </StyledDiscountFormContainer>
  );
}
